module.exports = __webpack_public_path__ + "static/img/2-2.143d302.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2-2.jpg
// module id = EXKS
// module chunks = 1